import { gql } from 'graphql-request';

import {
  FRAGMENT_AGENT_OFFICE,
  FRAGMENT_DISCOVERY_HC_ADDRESS,
  FRAGMENT_PROPERTY_LOCATION_HC,
} from './fragments';
import { FRAGEMENT_PROPERTY_STATE_LISTING } from './PropertyStateListing.graphql';

export const QUERY_LISTINGS_FOR_OFFICE = gql`
  query ListingsForOffice($officeMlsId: String!) {
    # HC CAPABILITY: agent-listings-product-access
    agents(agent: { officeMlsId: $officeMlsId }) {
      edges {
        node {
          email
          licenseNumber
          office
          identifiers {
            agentMlsIds {
              agentMlsId
              hcMlsId
            }
            emails
            names
            officeMlsIds {
              hcMlsId
              officeMlsId
            }
          }
          listings {
            edges {
              node {
                hcAddressSlug
                entityId
                id {
                  discovery {
                    hcMlsId
                    listingId
                  }
                }
                listingDetails {
                  hc {
                    listPrice
                    currentPrice
                    currentStatusDate
                    status
                  }
                }
                location {
                  reso {
                    unparsedAddress
                    city
                    stateOrProvince
                    postalCode
                  }
                }
                agentOffice {
                  hc {
                    agentOffice {
                      agentMlsId
                      email
                      name
                      office
                      officeMlsId
                      phoneOffice
                      type
                    }
                  }
                }
                media {
                  hc {
                    images {
                      order
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const FRAGMENT_AGENT_LISTING_NODE = gql`
  ${FRAGMENT_AGENT_OFFICE}
  ${FRAGMENT_PROPERTY_LOCATION_HC}
  ${FRAGMENT_DISCOVERY_HC_ADDRESS}
  fragment AgentListingNode on Listing {
    hcAddressSlug
    entityId
    location {
      hc {
        ...PropertyLocationHc
      }
      discovery {
        hcAddress {
          ...PropertyLocationDiscovery
        }
      }
    }
    mls {
      hcMlsId
      name
      nameShort
      regulations {
        logo
      }
    }
    agentOffice {
      hc {
        agentOffice {
          ...AgentOffice
        }
      }
    }
  }
`;
export const QUERY_AGENT_LISTINGS_FOR_VERIFICATION = gql`
  ${FRAGMENT_AGENT_LISTING_NODE}
  query AgentVerificationListings($mlsId: String!) {
    # HC CAPABILITY: agent-verification
    agents(agent: { mlsId: $mlsId }) {
      edges {
        node {
          email
          name
          office
          phone
          licenseNumber
          listings {
            edges {
              node {
                ...AgentListingNode
              }
            }
          }
          identifiers {
            mlsAgentIds {
              mlsAgentId
              hcMlsId
            }
          }
        }
      }
    }
  }
`;

export const QUERY_AGENT_LISTINGS_FOR_VERIFICATION_BY_EMAIL = gql`
  ${FRAGMENT_AGENT_LISTING_NODE}
  query AgentVerificationListingsByEmail($email: String!) {
    # HC CAPABILITY: agent-verification
    agents(agent: { email: $email }) {
      edges {
        node {
          email
          name
          office
          phone
          licenseNumber
          listings {
            edges {
              node {
                ...AgentListingNode
              }
            }
          }
          identifiers {
            mlsAgentIds {
              mlsAgentId
              hcMlsId
            }
          }
        }
      }
    }
  }
`;

export const QUERY_GOOGLE_LISTINGS_FOR_AGENT_EMAIL = gql`
  query GoogleListingsForAgentEmail(
    $listingAgentEmail: String!
    $first: Int
    $after: String
  ) {
    # HC CAPABILITY: agent-listings-product-access
    ${FRAGEMENT_PROPERTY_STATE_LISTING}
    products {
      googleListings {
        listings(
          listingAgentEmail: $listingAgentEmail
          first: $first
          after: $after
        ) {
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          resultSetInfo {
            totalCount
            totalCountType
          }
          edges {
            node {
              hcAddressId
              entityId
              listing {
                ...PropertyStateListingFragment
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_AGENTS = gql`
  ${FRAGMENT_AGENT_LISTING_NODE}
  query Agents($email: String!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # Note: tying this query to "pexp-product-access" since this capability is granted to every self-serve
    # user immediately after signup (this query is used in onboarding flow right after signup)
    agents(agent: { email: $email }) {
      edges {
        node {
          email
          name
          office
          phone
          licenseNumber
          listings {
            edges {
              node {
                ...AgentListingNode
              }
            }
          }
          identifiers {
            mlsAgentIds {
              hcMlsId
              mlsAgentId
            }
          }
        }
      }
    }
  }
`;
